import $ from "jquery";
import {onBlockLoaded, onDocumentLoaded} from "@plaudit/frontend-apis";
import {buildVariationEvent, findEventDataForProductId, fireViewItem, readBaseEventData} from "./view-item-common";

/**
 * view_item for the classic (jQuery) single-product page — this also covers the default block theme, whose
 * `add-to-cart-form` block renders the same legacy variations form. The block-only "Add to Cart + Options"
 * block uses the Interactivity API instead and is handled by the .mts generator alongside this one.
 *
 * On load, we fire the existing server-rendered view_item base event and start listening for ones added
 * via AJAX. For variable products we then listen for WooCommerce's `found_variation` event — a jQuery
 * custom event triggered on `.variations_form` whenever the shopper resolves a complete, purchasable
 * attribute combination — and fire a follow-up select_item carrying the variation's SKU (as item_variant)
 * and price. `found_variation` is dispatched through jQuery.trigger(), so it can only be observed via jQuery;
 * hence the delegated binding on document.body.
 */

//Initial view_item for each server-rendered product on the page + watch for products that get added later.
onBlockLoaded({
	blockOrClassName: "plaudit-woocommerce-ga-integration__view_item__item",
	onAdd(element) {
		const data = readBaseEventData(element, true);
		if (data === undefined) {
			return;
		}
		fireViewItem(data.event);
	}
});

onDocumentLoaded(() => {
	// 2. Follow-up select_item on each resolved variation, matched to its product via the form's data-product_id.
	const lastVariationId = new Map<string, number>();
	$(document.body).on("found_variation", ".variations_form", function(this: HTMLElement, _event: any, variation: any) {
		if (!variation) {
			return;
		}
		const productId = this.getAttribute("data-product_id") ?? "";
		const base = findEventDataForProductId(productId);
		// WooCommerce can re-trigger found_variation for an unchanged selection; only fire on a real change.
		if (!base || variation.variation_id === lastVariationId.get(productId)) {
			return;
		}
		lastVariationId.set(productId, variation.variation_id);
		const variant = variation.sku || (variation.variation_id != null ? String(variation.variation_id) : "");
		fireViewItem(buildVariationEvent(base, variant, parseFloat(variation.display_price)), "select_item");
	});
});
